module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='	<div class="filter-add js-filter-add ">\n		<div class="filter-add__container">\n			<div class="filter-add__button js-filter-toggle">		</div>\n			<div class="filter-popup js-filter-popup">\n				<div class="filter-popup__header">\n					<div class="filter-popup__title">Add filter</div>\n				</div>\n				<div class="filter-popup__body">\n					<ul class="filter-popup__list ">\n					</ul>\n				</div>\n\n			</div>\n		</div>\n\n	</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/components/devices-filter/templates/filter-add.html
// module id = 402
// module chunks = 0